var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278,
    height: 101,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M230.074 91.766a12.255 12.255 0 0 1-4.312-9.346c0-6.784 5.5-12.283 12.284-12.283 6.785 0 12.285 5.499 12.285 12.283 0 3.742-1.673 7.093-4.313 9.346h1.91a3.204 3.204 0 0 1 3.204 3.204h-25.904a3.204 3.204 0 0 1 3.204-3.204h1.642z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ACBDC2",
    d: "M179.424 65.683c-6.373.334-11.266 5.827-10.928 12.269.337 6.443 5.778 11.393 12.15 11.06 6.376-.335 11.268-5.826 10.93-12.27-.337-6.442-5.777-11.393-12.152-11.06z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeWidth: 5.76,
    d: "M191.577 76.742c-.338-6.442-5.778-11.393-12.153-11.06-6.373.335-11.266 5.828-10.928 12.27.337 6.443 5.778 11.393 12.15 11.06 6.376-.335 11.268-5.826 10.93-12.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACBDC2",
    d: "M107.716 81.137c-.338-6.442-5.779-11.393-12.152-11.06-6.375.335-11.267 5.828-10.93 12.27.338 6.443 5.777 11.393 12.152 11.06 6.374-.335 11.267-5.826 10.93-12.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeWidth: 5.76,
    d: "M107.716 81.137c-.338-6.442-5.779-11.393-12.152-11.06-6.375.335-11.267 5.828-10.93 12.27.338 6.443 5.777 11.393 12.152 11.06 6.374-.335 11.267-5.826 10.93-12.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9644B",
    d: "M154.637 77.898c.023-.446.023-.899-.001-1.355-.376-7.162-6.471-12.665-13.615-12.29-7.143.374-12.63 6.483-12.255 13.645.024.457.071.907.14 1.349l-77.395 4.056-.101-1.932c-.924-17.615 12.546-32.64 30.084-33.559l89.208-4.675c17.54-.92 32.504 12.616 33.427 30.23a1.929 1.929 0 0 1-1.82 2.033l-47.672 2.498z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeWidth: 5.76,
    d: "M146.072 44.577l25.682 32.394 30.555-1.571a1.929 1.929 0 0 0 1.82-2.032c-.923-17.615-15.888-31.15-33.427-30.23l-24.63 1.439z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9644B",
    stroke: "#1E0D2D",
    strokeWidth: 5.76,
    d: "M156.53 77.8c-.44-8.376-7.512-14.812-15.798-14.378-8.285.434-14.647 7.574-14.208 15.95L26.506 84.613a1.93 1.93 0 0 1-2.024-1.83c-.923-17.615 12.546-32.64 30.085-33.56l89.206-4.675c17.539-.919 32.505 12.616 33.428 30.23a1.93 1.93 0 0 1-1.822 2.033l-18.85.988z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M75.746 82.033c-.439-8.376-7.512-14.812-15.797-14.377-8.285.434-14.647 7.574-14.208 15.95.439 8.375 7.513 14.81 15.797 14.377 8.286-.435 14.647-7.575 14.208-15.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeWidth: 5.76,
    d: "M75.746 82.033c-.439-8.376-7.512-14.812-15.797-14.377-8.285.434-14.647 7.574-14.208 15.95.439 8.375 7.513 14.81 15.797 14.377 8.286-.435 14.647-7.575 14.208-15.95z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeWidth: 2.88,
    d: "M54.588 83.142c.18 3.435 3.082 6.076 6.48 5.898 3.4-.178 6.01-3.108 5.83-6.543-.18-3.436-3.081-6.077-6.481-5.899-3.4.178-6.009 3.108-5.829 6.544z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeLinecap: "square",
    strokeWidth: 5.76,
    d: "M159.342 43.732l-11.017-28.06a17.28 17.28 0 0 0-17.03-10.938l-55.272 3.03A15.84 15.84 0 0 0 61.23 21.196l-4.009 26.33m70.232-3.763l-13.07-36.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E0D2D",
    d: "M106.704 56.605l12.917-.677a1.445 1.445 0 0 0 1.37-1.517 1.445 1.445 0 0 0-1.52-1.365l-12.918.677a1.445 1.445 0 0 0-1.37 1.517 1.445 1.445 0 0 0 1.521 1.365"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeLinecap: "round",
    strokeWidth: 5.76,
    d: "M.72 98.836h270.56"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeWidth: 5.011,
    d: "M225.416 90.12a14.748 14.748 0 0 1-2.16-7.7c0-8.168 6.622-14.789 14.79-14.789 8.169 0 14.79 6.621 14.79 14.789 0 2.725-.742 5.331-2.089 7.584a5.708 5.708 0 0 1 2.89 4.966v2.506h-30.915V94.97a5.706 5.706 0 0 1 2.694-4.85z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeWidth: 2.88,
    d: "M231.954 82.7c0 3.301 2.647 5.977 5.912 5.977 3.267 0 5.914-2.676 5.914-5.976s-2.647-5.976-5.914-5.976c-3.265 0-5.912 2.675-5.912 5.976z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeWidth: 5.76,
    d: "M124.333 83.805l7.76 4.76-7.772 4.781-7.76-4.76z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.466,
    height: 4.329,
    x: 112.254,
    y: 93.786,
    fill: "#1E0D2D",
    rx: 2.164
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACBDC2",
    stroke: "#1E0D2D",
    strokeWidth: 2.88,
    d: "M136.72 78.84c0 2.106 1.688 3.813 3.77 3.813 2.084 0 3.773-1.707 3.773-3.812 0-2.106-1.689-3.812-3.772-3.812-2.083 0-3.771 1.706-3.771 3.812z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0D2D",
    strokeLinecap: "square",
    strokeWidth: 5.76,
    d: "M146.074 78.636l20.148-1.443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.844 73.586c.019 0 .038 0 .057.002l.01-.004-.067.002zm-.21-2.883c2.717 0 5.039.93 5.039 2.883 0 1.951-2.322 2.883-5.038 2.883s-5.038-.932-5.038-2.883v-.974l4.76-1.91h.278zm-.196-2.889l-.067-.003-.012.005a7.53 7.53 0 0 1 .079-.002zm.197 2.883c-2.603 0-5.038-.942-5.038-2.883 0-1.951 2.322-2.883 5.038-2.883s5.038.932 5.038 2.883v.974l-4.76 1.91h-.278z",
    stroke: "#1E0D2D",
    strokeWidth: 2.88
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenCar);
export default __webpack_public_path__ + "static/media/broken-car.927c62ea1b79e108e711f0c6a5b92b97.svg";
export { ForwardRef as ReactComponent };